(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function num(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      return num(cents, 2, ',', '.');
    });
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    function tick() {
      var n = new Date(), e = new Date(n); e.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((e - n) / 1000));
      $('[data-h]', el).textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      $('[data-m]', el).textContent = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      $('[data-s]', el).textContent = String(d % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]'), scrim = $('[data-cart-scrim]');
  function openCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open); scrim.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (open) { var x = $('[data-close-cart]'); if (x) x.focus(); }
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
    var tot = $('[data-cart-total]'); if (tot) tot.textContent = formatMoney(cart.total_price);
    var box = $('[data-cart-items]'); if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="empty">Your cart is empty.</p>'; return; }
    box.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '<span></span>';
      var plan = it.selling_plan_allocation ? '<small>' + it.selling_plan_allocation.selling_plan.name + '</small>' : '<small>One-time purchase</small>';
      var variant = it.variant_title ? '<small>' + it.variant_title + '</small>' : '';
      return '<div class="line">' + img + '<div><b>' + it.product_title + '</b>' + variant + plan +
        '<div class="qty-row"><button type="button" data-qty="' + (i + 1) + ':' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (i + 1) + ':' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div><b>' + formatMoney(it.final_line_price) + '</b></div>';
    }).join('');
  }
  function refreshCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); refreshCart(); openCart(true); }
    if (e.target.closest('[data-close-cart]') || e.target === scrim) openCart(false);
    var q = e.target.closest('[data-qty]');
    if (q && drawer && drawer.contains(q)) {
      var p = q.getAttribute('data-qty').split(':');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(p[0]), quantity: Math.max(0, Number(p[1])) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openCart(false); });

  /* ---------- product offer ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var dataEl = $('[data-product-json]', sec); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', sec) || $('form[action*="/cart/add"]', sec);
    var idInput = $('[data-variant-input]', sec), planInput = $('[data-plan-input]', sec);
    var planSelect = $('[data-plan-select]', sec);
    var addBtn = $('[data-add]', sec);

    function variantById(id) { return product.variants.filter(function (v) { return String(v.id) === String(id); })[0]; }
    function currentVariant() {
      var r = $('input[name^="bundle-"]:checked', sec);
      return variantById(r ? r.value : idInput.value) || product.variants[0];
    }
    function isSub() { var r = $('input[name^="ptype-"]:checked', sec); return !!(r && r.value === 'sub'); }
    function planPrice(v, planId) {
      var a = (v.selling_plan_allocations || []).filter(function (x) { return String(x.selling_plan_id) === String(planId); })[0];
      return a ? a.price : v.price;
    }
    function render() {
      var v = currentVariant(), planId = planSelect ? planSelect.value : '';
      var sub = isSub() && planId;
      var price = sub ? planPrice(v, planId) : v.price;
      var compare = v.compare_at_price && v.compare_at_price > price ? v.compare_at_price : (sub && v.price > price ? v.price : 0);
      idInput.value = v.id;
      planInput.value = sub ? planId : '';
      $('[data-price]', sec).textContent = formatMoney(price);
      $('[data-compare]', sec).textContent = compare ? formatMoney(compare) : '';
      var save = $('[data-save]', sec);
      if (compare) { save.style.display = ''; save.textContent = 'Save ' + Math.round((1 - price / compare) * 100) + '%'; } else { save.style.display = 'none'; }
      var sp = $('[data-sub-price]', sec); if (sp && planId) sp.textContent = formatMoney(planPrice(v, planId));
      var op = $('[data-once-price]', sec); if (op) op.textContent = formatMoney(v.price);
      var st = $('[data-sticky-price]'); if (st) st.textContent = formatMoney(price) + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    }
    $$('input[name^="bundle-"], input[name^="ptype-"]', sec).forEach(function (i) { i.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', function () {
      var s = $('input[name^="ptype-"][value="sub"]', sec); if (s) s.checked = true; render();
    });
    render();

    function addToCart() {
      var v = currentVariant(); if (!v.available) return;
      var item = { id: v.id, quantity: 1 };
      if (planInput.value) item.selling_plan = Number(planInput.value);
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(true); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
        .then(function () { if (addBtn) addBtn.disabled = false; });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    var sa = $('[data-sticky-add]'); if (sa) sa.addEventListener('click', addToCart);

    /* gallery */
    var track = $('[data-car-track]', sec);
    if (track) {
      var slides = $$('.slide', track), thumbs = $$('[data-car-thumbs] button', sec), count = $('[data-car-count]', sec), cur = 0;
      function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      function mark(i) { cur = i; thumbs.forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); }); if (count) count.textContent = (i + 1) + ' / ' + slides.length; }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); }); }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      var pv = $('[data-car-prev]', sec), nx = $('[data-car-next]', sec);
      if (pv) pv.addEventListener('click', function () { go(cur - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    }

    /* delivery estimate */
    var eta = $('[data-eta]', sec);
    if (eta) {
      var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) n--; } return d; };
      var f = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var now = new Date();
      eta.textContent = f(addBiz(now, Number(eta.dataset.min || 4))) + ' – ' + f(addBiz(now, Number(eta.dataset.max || 7)));
    }

    /* sticky add-to-cart bar */
    var sticky = $('[data-sticky]');
    if (sticky && addBtn) {
      var vis = function () {
        var show = addBtn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
        var b = $('[data-sticky-add]'); if (b) b.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', vis, { passive: true }); vis();
    }
  });

  /* ---------- testimonial carousel ---------- */
  $$('[data-tcar]').forEach(function (box) {
    var tr = $('[data-tcar-track]', box), cs = $$('.tcard', tr), dots = $('[data-tcar-dots]', box), cur = 0, tm;
    if (!cs.length) return;
    cs.forEach(function (c, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Review ' + (i + 1));
      b.addEventListener('click', function () { go(i); restart(); }); dots.appendChild(b);
    });
    function go(i) { var c = cs[i]; tr.scrollTo({ left: c.offsetLeft - (tr.clientWidth - c.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    function mark(i) { cur = i; cs.forEach(function (c, k) { c.classList.toggle('on', k === i); }); $$('button', dots).forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio > 0.6) mark(cs.indexOf(e.target)); }); }, { root: tr, threshold: [0.6] });
      cs.forEach(function (c) { io.observe(c); });
    }
    function restart() { clearInterval(tm); if (!reduce && cs.length > 1) tm = setInterval(function () { go((cur + 1) % cs.length); }, 6000); }
    tr.addEventListener('pointerdown', function () { clearInterval(tm); });
    mark(0); restart();
  });
})();
